<div [formGroup]="form">
  <div formGroupName="phoneChange">
    <form-field class="front" label="Registered Phone Number" i18n-label="@@support.phoneChange.oldPhone.label">
      <input type="text" readonly formControlName="oldPhone" placeholder="Loading your current phone number ..." i18n-placeholder="@@support.phoneChange.oldPhone.placeholder">
    </form-field>

    <form-field class="front" label="New Phone Number" i18n-label="@@support.phoneChange.newPhone.label">
      <input type="text" formControlName="newPhone" placeholder="the phone number you want to change to" i18n-placeholder="@@support.phoneChange.newPhone.placeholder">
    </form-field>

    <p class="text-sm mb-2" i18n="@@support.phoneChange.selfie.note">Please upload a copy of your passport as well as a selfie holding the passport in addition to a paper with the following written on it: "BitOasis", old phone number, new phone number, and your signature</p>
    <div class="row">
      <div class="col-lg-6">
        <file-uploader [maxSize]="1024 * 5" [allowedTypes]="['png', 'jpg', 'jpeg', 'pdf']" class="w-100 mb-3" (select)="onSelfieSelect($event)" (remove)="onSelfieRemove()">
          <input #file type="file" class="input">
          <ng-template #placeholder>
            <img src="assets/images/icons/upload-selfie.svg" alt="">
            <div class="text-primary pt-2 text-sm" i18n="@@support.phoneChange.selfie.label">Selfie</div>
          </ng-template>
        </file-uploader>
      </div>
      <div class="col-lg-6">
        <file-uploader [maxSize]="1024 * 5" [allowedTypes]="['png', 'jpg', 'jpeg', 'pdf']" class="w-100 mb-3" (select)="onPassportSelect($event)" (remove)="onPassportRemove()">
          <input #file type="file" class="input">
          <ng-template #placeholder>
            <img src="assets/images/icons/upload-passport.svg" alt="">
            <div class="text-primary pt-2 text-sm" i18n="@@support.phoneChange.passport">Passport copy</div>
          </ng-template>
        </file-uploader>
      </div>
    </div>

    <form-field class="front textarea" label="Ticket Message" i18n-label="@@support.phoneChange.message.label">
      <textarea formControlName="message" placeholder="Enter your ticket message" rows="5" i18n-placeholder="@@support.phoneChange.message.placeholder"></textarea>
    </form-field>
  </div>
</div>
